const TOKEN_KEY = "dh_email_verify_tokens";
const TTL_MS = 1000 * 60 * 60 * 48;

function readTokens() {
  try {
    return JSON.parse(localStorage.getItem(TOKEN_KEY) || "[]");
  } catch {
    return [];
  }
}

function writeTokens(rows) {
  localStorage.setItem(TOKEN_KEY, JSON.stringify(rows.slice(-500)));
}

export function issueVerificationToken(userId, email) {
  const token = crypto.randomUUID();
  const row = {
    token,
    userId,
    email: String(email || "").toLowerCase(),
    createdAt: new Date().toISOString(),
    expiresAt: new Date(Date.now() + TTL_MS).toISOString(),
  };
  writeTokens([row, ...readTokens().filter((item) => item.userId !== userId)]);
  return row;
}

export function verificationPath(token) {
  return `/verify-email?token=${encodeURIComponent(token)}`;
}

export function absoluteVerificationUrl(token) {
  if (typeof window === "undefined") return verificationPath(token);
  return `${window.location.origin}${verificationPath(token)}`;
}

export function findVerificationToken(token) {
  const raw = String(token || "").trim();
  if (!raw) return null;
  const now = Date.now();
  return (
    readTokens().find((row) => {
      if (row.token !== raw) return false;
      return new Date(row.expiresAt).getTime() > now;
    }) || null
  );
}

export function consumeVerificationToken(token) {
  const match = findVerificationToken(token);
  if (!match) return null;
  writeTokens(readTokens().filter((row) => row.token !== token));
  return match;
}

export function latestVerificationLink(userId) {
  const row = readTokens().find((item) => item.userId === userId);
  return row ? absoluteVerificationUrl(row.token) : "";
}
